import HomeSearch from "../../components/elements/HomeSearch"
import Container from "../../layout/Container"
import Navbar from "../../layout/Navbar"
import Hero from "../../assets/images/hero.png";
import BlogCard from "../../components/cards/BlogCard";
import { useParams } from "react-router-dom";
import { useFetch } from "../../hooks/useFetch";
import { getBlogById, recentBlogs } from "../../apis";
import { dateFormat } from "../../utils";
import useWidth from "../../hooks/useWidth";
import BlogDetailsMobile from '../mobile/BlogDetails'
import Loader from "../../components/elements/Loader";


export default () => {
    const params = useParams()
    const [blog,,loading] = useFetch(getBlogById, {}, params.blogId)
    const [blogs] = useFetch(recentBlogs, [])
    const width = useWidth()

    return (
        <>
        <Loader loading={loading} />

            {width < 992 ? <BlogDetailsMobile blog={ blog} blogs={blogs} /> :
            <>
                <Navbar gradient />
    
                <Container>
                    <section className="blog-details">
                        <div className="page-header">  
                            <div className="d-flex justify-content-center flex-column align-items-center ">
                                <h1 className="custom-heading xx-bold">Search Result</h1>
                                <HomeSearch placeholder={"Search for Blogs & Stories"} />
                            </div>
                        </div>
                        <div className="container">
                            <p className="text-saffron fs-4">{ blog.title }</p>
    
                            <div className="row mt-5">
                                <div className={`col-md-12 ${ blog.files?.length > 1 ? "col-lg-9" : "col-lg-12" }`}>
                                    <div style={{ width: "100%", height: "500px" }}>
                                        <img src={blog.files?.at(0)?.Url || Hero} className="w-100 h-100 rounded-4 image-cover" />
                                    </div>
                                </div>
                                {blog.files?.at(1)?.Url && <div className="col-lg-3 col-md-4">
                                    <div className="row">
                                        <div className="col p-0">
                                            <div className="p-2" style={{ width: "100%", height: "250px" }}>
                                                <img src={ blog.files?.at(1)?.Url } className="rounded-4 w-100 h-100 image-cover" />
                                            </div>
                                        </div>
    
                                    </div>
                                    {blog.files?.at(2)?.Url && <div className="row">
                                        <div className="col p-0">
                                            <div className={`p-2 position-relative  w-100 ${ blog.files?.length > 3 && "group-photos"}`} style={{ height: "250px" }}>
                                                <img src={blog.files?.at(2)?.Url || Hero} className="rounded-4 w-100 h-100 image-cover" />
                                                { blog.files?.length > 3 && <div className="position-absolute text-white bold text-center" style={{ top: "40%", left: "35%" }}>
                                                    <p className="fs-5">+{ blog.files?.length - 2} Photos</p>
                                                </div>}
                                            </div>
                                        </div>
                                    </div>}
                                </div>}
    
                            </div>
    
                            <div className="d-flex align-items-center my-4">
                                <p className="text-primary mb-1 me-3 ">
                                    <span className="dot me-2 bg-primary me-1" style={{ height: '8px', width: '8px', borderRadius: '50%', display: 'inline-block' }}></span>
                                    { dateFormat( blog.createdAt )}
                                </p>
                                <p className='text-primary mb-1 '>
                                    <span className="dot me-2 bg-primary me-1" style={{ height: '8px', width: '8px', borderRadius: '50%', display: 'inline-block' }}></span>
                                    { blog.cityId?.name }
                                </p>
                            </div>
                            
                            <div>
                                <p dangerouslySetInnerHTML={{ __html: blog?.content }}></p>
                            </div>
    
                            <h2 className="custom-text-color my-5">Similar Blogs</h2>
    
                            <div className="d-flex overflow-auto scrollbar-hidden">
                                {
                                    blogs?.map(( blog, i )=> 
                                        <div className="col-lg-4" key={i}>
                                            <div className="m-2">
                                                <BlogCard data={blog} />
                                            </div>
                                        </div>
                                    )
                                }
                            </div>
                        </div>
    
                    </section>
    
                </Container>
            </>}
        </>
    )
}
